import { render, staticRenderFns } from "./CommentReactionPicker.vue?vue&type=template&id=0dd145fc&scoped=true&"
import script from "./CommentReactionPicker.vue?vue&type=script&lang=js&"
export * from "./CommentReactionPicker.vue?vue&type=script&lang=js&"
import style0 from "./CommentReactionPicker.vue?vue&type=style&index=0&id=0dd145fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd145fc",
  null
  
)

export default component.exports